<template>
    <div id="map">
      <popover></popover>
      <app-legend
        :provinces="provinces"
        :boundary="boundary"
        :mining="mining"
        :logging="logging"
        :protectedAreas="protectedAreas"
        :agriculture="agriculture"
        :status=status
        :smp-approved="smpApproved"
      ></app-legend>
    </div>
</template>
<script>
import { initMap, filterLayers, hoverLayer, unhoverLayer } from "./index";
import Legend from "@/components/legend/LegendControl";
import Popover from "@/components/map/Popover";
export default {
  props: [
    "filteredItems",
    "filterUrl",
    "bboxFilter",
    "status",
    "smpApproved"
  ],
  components: {
    appLegend: Legend,
    popover: Popover,
  },
  data() {
    return {
      is_authenticated: false,
      featureGroup: null,
      provinces: false,
      boundary: false,
      mining: false,
      logging: false,
      protectedAreas: false,
      agriculture: false,
    };
  },
  watch: {
    filteredItems() {
      filterLayers(this);
    }
  },
  methods: {
    async mapInit() {
      await initMap(this);
    }
  },
  mounted() {
    this.mapInit();
  },
  created() {
    // is_auth set in django list.html template
    this.is_authenticated = is_auth;
    let _vm = this;
    _vm.$root.$on("table-hovered", app => {
      hoverLayer(_vm, app.id);
    });
    _vm.$root.$on("table-unhovered", app => {
      unhoverLayer(_vm, app.id);
    });
  }
};
</script>
<style>
#map {
  width: 100%;
  height: calc(100vh - 130px);
}
</style>
